<template>
    <eventi-view-component :jsonData="jsonData" :pathResource="pathResource" :pathResourceFirma="pathResourceFirma" :utente="utente" :titoloEvento="titoloEvento" :linkPrintData="linkPrintData">
        <template slot="tab-content-event">
            <dati-clinico-strum-ricovero-view-component :idEvento="id" @update="onUpdateJsonData"></dati-clinico-strum-ricovero-view-component>
        </template>
    </eventi-view-component>
</template>
<script>
import UtilityMixins from "../../../../../utility/UtilityMixin";
import EventiViewComponent from "../../../base/components/EventiViewComponent.vue";
import EventiMixins from "../../../utility/mixins/EventiMixins";
import DatiClinicoStrumRicoveroViewComponent from "./DatiClinicoStrumRicoveroViewComponent.vue";
export default {
    mixins: [UtilityMixins, EventiMixins],
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { DatiClinicoStrumRicoveroViewComponent, EventiViewComponent },
    data() {
        return {
            titoloEvento: "Dati Clinico-Strumentali-S.C.A.",
            linkback: null,
            pathResource: "/cardiodaticlinicistrumentaliric",
            pathResourceFirma: "/cardiodaticlinicistrumentaliric",
            jsonData: {},
            id: null,
            linkPrintData: null,
            showModalLoading: false,
            fontScale: 2,
            linkedit: null,
            pathRestValidation: "/validation",
            isThisFirmato: false,
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return EventiMixins.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.jsonData.idPaziente = this.$route.query.idPaziente;
        me.id = this.$route.params.id;
    },
    methods: {
        updateStatoFirma(firmato) {
            console.log(firmato);
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
            me.linkPrintData = "/pazienteeventi/print/" + me.jsonData.id;
        },
    },
};
</script>
